import {useQuery} from 'react-query'
import {axiosClientAuth} from '../utils/axiosClient'

export interface UserProfile {
  id: number
  name: string
  email: string
  phone: string
  type: string
  status: Record<string, {active: boolean}>
  created_at: string
}

const fetchUserProfile = async (): Promise<UserProfile> => {
  const res = await axiosClientAuth.get('/auth/profile/')
  return res.data.data
}

export const useUserProfile = () => {
  return useQuery<UserProfile>('user-profile', fetchUserProfile, {
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    retry: 1,
  })
}
